<template>
    <div class="material-container">
        <div class="material-carousel">
            <el-carousel ref="carousel" height="200px" :interval="10000">
                <el-carousel-item v-for="(item, index) in shedList" :key="index">
                    <div @click="getIntoShed(item)" class="material-item">
                        <div class="top">
                            <div class="name">料棚名称</div>
                            <div class="name_">{{ item.areaName + "-" + item.shedName }}</div>
                        </div>
                        <div class="bottom">
                            <div class="info">料棚信息</div>
                            <div class="info_">{{ item.material }}</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    inject: ["updateShedObj","updateShedList"],
    props: ["matrix", "x", "y"],
    data() {
        return {
            shedList: []
        }
    },
    methods: {
        getMaterialList() {
            let getShedListUrl = CONFIG.requestName + this.$apiOpt.findShedList;
            this.$apiUtils
                .get(getShedListUrl, {
                    customerId: this.$store.state.customerId,
                })
                .then((data) => {
                    this.shedList = data;
                    this.getShedList()
                });
        },
        getShedList() {
            let getVdmListUrl = "https://vis.bmetech.com/vis/vdm15000/list";
            this.$apiUtils
                .get(getVdmListUrl, {
                    customerId: this.$store.state.customerId,
                })
                .then((data) => {
                    if(data && data.length) {
                        data.forEach(item => {
                            item.isVDM = true;
                            this.shedList.push(item);
                        })
                    }
                });
        },
        getIntoShed(obj) {
            this.$router.push({ path: "/UnorganizedMod", hash: "" });
            setTimeout(() => this.$store.commit("updateMaterialShedObj", obj), 1000)
        }
    },  
    mounted() {
        let w = $(this.$refs.mathStockyard).outerWidth();
        let h = $(this.$refs.mathStockyard).outerHeight();
        this.$emit("componentInit", {
            w: w,
            h: h,
            matrixType: this.matrix,
            x: this.x,
            y: this.y,
        });
        this.getMaterialList();
        setTimeout(() => {
            this.$refs.carousel.setActiveItem(3)
        }, 500)
    },
}
</script>

<style lang="scss" scoped>
.material {
    &-container {
        width: 600px;
        height: 250px;
    }
    &-carousel {
        width: 100%;
        height: 100%;
        padding-top: 20px;
        cursor: pointer;
    }
    &-item {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 15px;
        .top {
            margin-bottom: 10px;
        }
        .top,
        .bottom {
            flex: 1;
            display: flex;
            justify-content: space-between;
            .name,.info {
                height: 100%;
                flex: 1;
                font-size: 36px;
                text-shadow: 8px 8px 8px rgb(255 255 255 / 50%);
                font-family: "workOrderFont";
                text-align: center;
                background-color: rgb(2,45,64, .8);
                line-height: 80px;
                margin-right: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .name_, .info_ {
                height: 100%;
                line-height: 80px;
                background-color: rgb(2,45,64, .8);
                flex: 2;
                color: rgba(244, 196, 143, 1);
                font-size: 30px;
                text-shadow: 8px 8px 8px rgb(255 255 255 / 50%);
                font-family: "workOrderFont";
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
:deep(.el-carousel__indicators--horizontal) {
    opacity: 0;
}
</style>